import { render } from "./appicons.vue?vue&type=template&id=70ce2362&scoped=true"
import script from "./appicons.vue?vue&type=script&lang=js"
export * from "./appicons.vue?vue&type=script&lang=js"

import "./appicons.vue?vue&type=style&index=0&id=70ce2362&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ce2362"]])

export default __exports__